import { useEffect, useRef, useState } from 'react';

/**
 * useRevealOnScroll — trigger entrance animation when
 * element crosses 15% visibility. Fires only once per mount.
 */
export function useRevealOnScroll({ threshold = 0.15 } = {}) {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) { setRevealed(true); return; }

    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setRevealed(true);
        io.disconnect();
      }
    }, { threshold });
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);

  return [ref, revealed];
}
